import { z } from "zod";

export type LangRestrictionSettingLanguageInput = z.infer<typeof LangRestrictionSettingLanguageInputSchema>;
export const LangRestrictionSettingLanguageInputSchema = z.object({
  lang_cd: z.string(),
  selected: z.boolean(),
});

export type LangRestrictionSettingSubMenuInput = z.infer<typeof LangRestrictionSettingSubMenuInputSchema>;
export const LangRestrictionSettingSubMenuInputSchema = z.object({
  sub_menu_id: z.number(),
  restricted: z.boolean(),
});

export type LangRestrictionSettingLanguage = z.infer<typeof LangRestrictionSettingLanguageSchema>;
export const LangRestrictionSettingLanguageSchema = z.object({
  lang_cd: z.string(),
  name: z.string(),
  selected: z.boolean(),
});

export type LangRestrictionSettingSubMenu = z.infer<typeof LangRestrictionSettingSubMenuSchema>;
export const LangRestrictionSettingSubMenuSchema = z.object({
  sub_menu_id: z.number(),
  restricted: z.boolean(),
  configurable: z.boolean(),
  sub_menu_name: z.string(),
  sub_menu_type: z.string(),
  main_menu_name: z.string(),
});

export type LangRestrictionSetting = z.infer<typeof LangRestrictionSettingSchema>;
export const LangRestrictionSettingSchema = z.object({
  languages: z.array(LangRestrictionSettingLanguageSchema),
  sub_menus: z.array(LangRestrictionSettingSubMenuSchema),
});

export type LangRestrictionStatus = z.infer<typeof LangRestrictionStatusSchema>;
export const LangRestrictionStatusSchema = z.object({
  restricted: z.boolean(),
  configurable: z.boolean(),
});

export type LangRestrictionGuestLanguage = z.infer<typeof LangRestrictionGuestLanguageSchema>;
export const LangRestrictionGuestLanguageSchema = z.object({
  lang_cd: z.string(),
  name: z.string(),
});

export type LangRestriction = z.infer<typeof LangRestrictionSchema>;
export const LangRestrictionSchema = z.object({
  configurable: z.boolean(),
  available_languages: z.array(LangRestrictionGuestLanguageSchema),
});
